export class Loader {
    constructor(accountId = null) {
        this.accountId = accountId;
        if (typeof window === 'undefined') {
            throw new Error('Appcues is supported only in browser environment');
        }
    }
    load() {
        if (typeof this.api !== 'undefined') {
            return Promise.resolve(this.api);
        }
        if (typeof this.loader !== 'undefined') {
            return this.loader;
        }
        return this.loader = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
            if (window['Appcues']) {
                resolve(window['Appcues']);
                return;
            }
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = !0;
            script.src = `//fast.appcues.com/${this.accountId}.js`;
            script.onload = () => {
                resolve(window['Appcues']);
            };
            script.onerror = (error) => {
                reject(error);
            };
            document.head.appendChild(script);
        });
    }
}
//# sourceMappingURL=loader.js.map